import { coreService } from 'Src/network/AutomatedService';
import { definitions } from 'Src/vendor/posapi/pos';

type DayPartSchedule = definitions['types.DayPartSchedule'];
type DayPartScheduleGetAllResponse = definitions['daypartschedule.POSDayPartSchedule'];

const serviceKey = {
  getAll: 'POS:GET:DayPartSchedules',
} as const;

const service = {
  getAll: async () => await coreService[serviceKey.getAll]({}),
} as const;

export default service;
export { serviceKey };
export type { DayPartSchedule, DayPartScheduleGetAllResponse };

